import { FC, SVGProps } from 'react';
import { useAccordianContext } from '../context/accordian-context';
import { twMerge } from 'tailwind-merge';

interface AccordianIconProps extends SVGProps<SVGSVGElement> {}

const AccordianIcon: FC<AccordianIconProps> = (props) => {
    const { className, ...rest } = props;

    const { isExpanded } = useAccordianContext();

    return (
        <svg
            viewBox="0 0 8 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={9}
            {...rest}
            className={twMerge(
                'text-grayscale-500 transition-transform duration-200',
                isExpanded && 'rotate-180',
                className
            )}
        >
            <path d="M7 1L4 4 1 1" stroke="currentColor" strokeWidth={1} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default AccordianIcon;
